import {
  HIDE_LOOM_PRO_VIDEO,
  SHOW_CONNECT_BUTTONS,
  SHOW_LOOM_PRO_VIDEO,
} from '../constants/actions';

const DEFAULT_HOMEPAGE_STATE = {
  accepted_terms: false,
  email_pass_mode: false,
  sign_in_mode: false,
  showLoomProVideo: false,
  showConnectButtons: false,
};

const homepageReducer = (state = DEFAULT_HOMEPAGE_STATE, action) => {
  switch (action.type) {
    case SHOW_LOOM_PRO_VIDEO:
      return {
        ...state,
        showLoomProVideo: true,
      };

    case HIDE_LOOM_PRO_VIDEO:
      return {
        ...state,
        showLoomProVideo: false,
      };

    case SHOW_CONNECT_BUTTONS:
      return {
        ...state,
        showConnectButtons: true,
      };

    default:
      return state;
  }
};

export default homepageReducer;
